"use client"

import { useState } from "react"
import { useWallet } from "@/lib/wallet-provider"
import { IdentitySigil } from "@/components/ui/identity-sigil"
import { WalletIcon, LoaderIcon } from "@/components/icons/pixel-icons"
import { HUD_ICON_BUTTON_CLASS } from "@/components/game-ui/hud/hud-button-style"
import { WalletModal } from "./wallet-modal"

/**
 * Icon-only wallet button (no text label), styled to sit next to the
 * hamburger menu button in the top HUD.
 *
 * - Disconnected: wallet icon -> starts connect flow
 * - Connecting: spinner
 * - Connected: identity sigil -> opens the wallet modal
 */
export const WalletButton = () => {
  const { status, identityKey, connect, lastError } = useWallet()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showError, setShowError] = useState(false)

  const handleClick = async () => {
    if (status === "connected") {
      setIsModalOpen(true)
      return
    }
    if (status === "connecting") return
    setShowError(false)
    await connect()
  }

  return (
    <>
      <button
        id="wallet-button"
        onClick={handleClick}
        onMouseEnter={() => lastError && setShowError(true)}
        onMouseLeave={() => setShowError(false)}
        className={HUD_ICON_BUTTON_CLASS}
        title={status === "connected" ? "Wallet" : "Connect wallet"}
        aria-label={status === "connected" ? "Open wallet" : "Connect wallet"}
      >
        {status === "connected" && identityKey ? (
          <IdentitySigil value={identityKey} size={20} className="rounded" />
        ) : status === "connecting" ? (
          <LoaderIcon size={20} />
        ) : (
          <WalletIcon size={20} />
        )}
      </button>

      {/* Connection error hint (e.g. no BRC-100 wallet installed) */}
      {showError && lastError && status !== "connected" && (
        <div className="absolute top-full right-0 mt-2 w-56 bg-black/90 text-red-300 text-xs p-2 rounded-lg border border-red-800 z-50">
          {lastError}
        </div>
      )}

      <WalletModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
